import React from 'react';
import { compose } from 'recompose';
import styled, { StylesProps } from '../../../lib/styles';
import { Brand } from '../../../lib/theme';

import valuePropositionStyles from './ValuePropositions_styles';
import Spacer from '../../../components/presentational/Spacer';
import Typography from '../../../components/presentational/Typography';
import { BaseBlockProps, ValueProposition } from '../../../models/travelCollection';
import Image from '../../../components/presentational/Image';

export interface ValuePropositionsProps extends BaseBlockProps {
  brand?: Brand;
  valuePropositions: ValueProposition[];
}

const ValuePropositions = ({
  brand,
  styles,
  valuePropositions,
  isV2Collection = false,
}: ValuePropositionsProps & StylesProps<typeof valuePropositionStyles>) => (
  <Spacer align={'center'} space={isV2Collection ? 0 : 'm'} className={`${isV2Collection ? `v2-collection-block` : null} ${styles.container}`}>
    <div className={styles.innerContainer}>
      {valuePropositions.map(({ text, imageURL }, i) => (
        <Spacer
          width={260}
          className={styles.valueProposition}
          align={'center'}
          key={i}
        >
          <Image
            alt={`Value proposition #${i + 1}`}
            src={imageURL}
            width={180}
            resizeWidth={180}
            resizeFit={'min'}
          />
          <Typography
            brand={brand}
            dangerouslySetInnerHTML={{ __html: text }}
            family={'primary'}
          />
        </Spacer>
      ))}
    </div>
  </Spacer>
);

export default compose(styled(valuePropositionStyles))(ValuePropositions);
